export enum PrivacyType{
  Privacy = "watch_privacy_policy",
  License = "watch_user_license",
  Information = "user_info_privacy",
  Location = "gps_privacy",
  Experience = "watch_user_exp",
  Eensitive = "user_sensitive_info",
  Healthy = "sport_healthy_privacy",
  Healthy_Abstract = "sport_healthy_privacy_abstract",
  Risk_Tips = "risk_tips",
  SmartCard = "smartcard",
  Eensitive_v3= "user_sensitive_info_v3",
  Experience_v3 = "watch_user_exp_v3",
  License_v3 = "watch_user_license_v3",
}